import { useQuery } from "@tanstack/react-query";
import { fetchWarehousePreferences } from "../../../../../../enums/queryFunction/Fetch";
import { WAREHOUSE_PREFERENCES } from "../../../../../../enums/QueryKeys";

export function useGetWarehousePreferences(clinicId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [WAREHOUSE_PREFERENCES, clinicId],
    queryFn: () => fetchWarehousePreferences(clinicId),
    enabled: Boolean(clinicId),
  });

  return { data, isLoading, error, refetch };
}
